import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue";
import { weixinAuthorizeUserInfo } from '@/features/auth/check';
import useMeStore from '@/features/auth/useMeStore';
import { useRoute } from 'vue-router';
import { computed, reactive } from 'vue';
export default {
  __name: 'weixinAuthorizeUserInfoMask',
  setup(__props) {
    const meStore = useMeStore();
    const route = useRoute();
    const popupState = reactive({
      show: false,
      maskClick() {
        this.show = true;
        weixinAuthorizeUserInfo();
      }
    });
    const show = computed(() => {
      if (route.path.match(/citys|update/)) {
        return 0;
      }
      return meStore.me.is_new;
    });
    return (_ctx, _cache) => {
      const _component_van_popup = _resolveComponent("van-popup");
      return _openBlock(), _createElementBlock(_Fragment, null, [show.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "fixed inset-0 translate-z-0 bg-white/10 z-50",
        onClick: _cache[0] || (_cache[0] = (...args) => popupState.maskClick && popupState.maskClick(...args))
      })) : _createCommentVNode("", true), show.value ? (_openBlock(), _createBlock(_component_van_popup, {
        key: 1,
        show: popupState.show,
        "onUpdate:show": _cache[1] || (_cache[1] = $event => popupState.show = $event),
        position: "top",
        class: "rounded-b-lg",
        onClose: popupState.close
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [_createElementVNode("div", {
          class: "p-2"
        }, [_createElementVNode("div", {
          class: "font-bold text-xl"
        }, "为给您提供更好的服务"), _createElementVNode("div", null, " 根据微信平台相关政策调整，为优化用户使用体验，请授权用户头像和昵称相关信息 ")], -1)])),
        _: 1,
        __: [2]
      }, 8, ["show", "onClose"])) : _createCommentVNode("", true)], 64);
    };
  }
};